var map = {
	"./additionalInfoIcon.svg": 519,
	"./arrowLeftIcon.svg": 520,
	"./arrowMediumTop.svg": 521,
	"./arrowRightIcon.svg": 522,
	"./arrowRightIconSharp.svg": 523,
	"./arrowRightSmallIcon.svg": 524,
	"./arrowScalableIcon.svg": 525,
	"./arrowSelect2.svg": 526,
	"./arrowSelectIcon.svg": 527,
	"./benefit1.svg": 528,
	"./benefit2.svg": 529,
	"./benefit3.svg": 530,
	"./cardsIcon.svg": 531,
	"./circleInfoIcon.svg": 532,
	"./copyIcon copy.svg": 533,
	"./copyIcon.svg": 534,
	"./crossIcon.svg": 535,
	"./crossIcon2.svg": 536,
	"./crossIcon3.svg": 537,
	"./crossIconSmall.svg": 538,
	"./crossSmallIcon.svg": 539,
	"./defaultCategoryIcon.svg": 540,
	"./depNumberIcon.svg": 541,
	"./elfCentralIcon.svg": 542,
	"./equalitySign.svg": 543,
	"./errorIcon.svg": 430,
	"./eyeClosedIcon.svg": 544,
	"./eyeOpenIcon.svg": 545,
	"./favoritesIcon.svg": 546,
	"./favoritesLabelIcon.svg": 547,
	"./filterDivider.svg": 548,
	"./filterIcon.svg": 549,
	"./frequencyIcon.svg": 550,
	"./fsAmountIcon.svg": 551,
	"./fullScreenIcon.svg": 552,
	"./gameIcon.svg": 553,
	"./hamburgerIcon.svg": 554,
	"./infoIcon.svg": 555,
	"./infoSymbol.svg": 556,
	"./levelBackground.svg": 557,
	"./levelBackgroundNew.svg": 558,
	"./linkIcon.svg": 559,
	"./lockIcon.svg": 560,
	"./lockSharpIcon.svg": 561,
	"./maxBonusAmountIcon.svg": 562,
	"./maxWinFsIcon.svg": 563,
	"./menuIcon.svg": 564,
	"./minDepIcon.svg": 565,
	"./noTournamentIcon.svg": 566,
	"./playIcon.svg": 567,
	"./polygon.svg": 568,
	"./preloaderDotsAnimation.svg": 569,
	"./preloaderSpinnerAnimation.svg": 570,
	"./presentIcon.svg": 571,
	"./promoIcon.svg": 572,
	"./recentIcon.svg": 573,
	"./search2Icon.svg": 574,
	"./search3Icon.svg": 575,
	"./sharpTickIcon copy.svg": 576,
	"./sharpTickIcon.svg": 577,
	"./smallInfoSymbol.svg": 578,
	"./smoothArrowIcon.svg": 579,
	"./successIcon.svg": 580,
	"./supportIcon.svg": 581,
	"./tag1Icon.svg": 582,
	"./tag2Icon.svg": 583,
	"./tag3Icon.svg": 584,
	"./tag4Icon.svg": 585,
	"./tickIcon.svg": 586,
	"./unverified.svg": 587,
	"./verified.svg": 588,
	"./wagerIcon.svg": 589,
	"./wagerTimeIcon.svg": 590,
	"./warningIcon.svg": 591
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 518;